import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_PROFESIONES = 'ALL_PROFESIONES';
export const LOADING_ALL_PROFESIONES = 'LOADING_ALL_PROFESIONES';
export const ACTIVO_PROFESIONES = 'ACTIVO_PROFESIONES';
export const PARAMS_PROFESIONES = 'PARAMS_PROFESIONES';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
};

export const profesionesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PROFESIONES:
      return {
        ...state,
        all: action.payload.data,
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case LOADING_ALL_PROFESIONES:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_PROFESIONES:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_PROFESIONES:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
